export default __webpack_public_path__ + "static/2171-cd4aee3c95fcb57829af8c041489ea52.gif";